/** Compact "This folder ▾" chip that picks where a search looks; used in the search bar and the refine row. */
import { useI18n } from '@platform/i18n';
import { Button, cn, DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@platform/ui';
import { ChevronDownIcon } from 'lucide-react';
import type { SearchScope } from './mail-context';

const SEARCH_SCOPES: readonly SearchScope[] = ['folder', 'folderTree', 'mailbox', 'allMailboxes'];

export interface SearchScopeMenuProps {
  scope: SearchScope;
  onChange: (scope: SearchScope) => void;
  className?: string;
}

export function SearchScopeMenu({ scope, onChange, className }: SearchScopeMenuProps) {
  const { t } = useI18n();
  const name = t(`webmail.searchScope.${scope}`);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          aria-label={t('webmail.searchScope.chipLabel', { scope: name })}
          className={cn('h-7 shrink-0 gap-1 rounded-full px-2.5 text-xs font-normal', className)}
        >
          <span className="truncate">{name}</span>
          <ChevronDownIcon aria-hidden className="size-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup value={scope} onValueChange={(value) => onChange(value as SearchScope)}>
          {SEARCH_SCOPES.map((option) => (
            <DropdownMenuRadioItem key={option} value={option}>
              {t(`webmail.searchScope.${option}`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
